import { DELETE_WATCH_LIST_ENTRY } from '../types';
import createAsyncActions from '../../../utilities/createAsyncActions';

export const {
  deleteWatchListEntry,
  deleteWatchListEntryPending,
  deleteWatchListEntryFulfilled,
  deleteWatchListEntryRejected,
} = createAsyncActions(DELETE_WATCH_LIST_ENTRY, 'deleteWatchListEntry');


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/actions/deleteWatchListEntryActions.js